<template>
    <div>
        <app-data-table
            v-if="!!tableData"
            :fields="fields"
            :items="tableData.data"
            :from="tableData.from"
            :to="tableData.to"
            :current-page="tableData.current_page"
            :last-page="tableData.last_page"
            :total="tableData.total"
            :per-page="tableData.per_page"
            :on-change-page="onChangePage"
            @sort="onSort"
        >
            <template slot="photo" slot-scope="{ item }">
                <div :style="`background-image: url(${item.photo_url});width: 50px; height: 50px; border-radius: 50%;background-size: cover;`"></div>
            </template>
            <template slot="actions" slot-scope="{ item }">
                <b-btn size="sm" variant="primary" v-if="userCan('update-pet')" @click="$emit('edit', item)"><i class="fa fa-pencil"></i></b-btn>
                <b-btn size="sm" variant="danger" v-if="userCan('delete-pet')" @click="$emit('delete', item)"><i class="fa fa-trash"></i></b-btn>
            </template>
        </app-data-table>
        <b-alert show v-else>Esperando datos...</b-alert>
    </div>
</template>
<script>
export default {
    props: {
        tableData: {
            type: [String, Object],
            default: ''
        },
        onChangePage: {
            type: Function
        }
    },
    data: () => ({
        fields
    }),
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx);
        }
    }
}
const fields = [
    {
        key: 'photo',
        label: 'Foto',
        sortable: false
    },
    {
        key: 'name',
        label: 'Nombre',
        orderBy: 'pets.name'
    },
    {
        key: 'pet_breed.pet_specie.name',
        label: 'Especie',
        orderBy: 'pet_species.name'
    },
    {
        key: 'pet_breed.name',
        label: 'Raza',
        orderBy: 'pet_breeds.name'
    },
    {
        key: 'age',
        label: 'Edad',
        orderBy: 'pets.age'
    },
    {
        key: 'client.name',
        label: 'Cliente',
        orderBy: 'clients.name'
    },
    {
        key: 'structure.venue.name',
        label: 'Sede',
        orderBy: 'venues.name'
    },
    {
        key: 'structure.name',
        label: 'Estructura',
        orderBy: 'structures.name'
    },
    {
        key: 'actions',
        label: 'Acciones'
    },
]
</script>